import { useAppSelector } from "integrations/redux/hooks"
import { useBoundingBoxLayerLabelData } from "plugins/shared/layers/BoundingBoxLayer.class"
import { Marker } from "react-map-gl"
import { selectLockedLayersMap, selectSelectedLayerIds } from "panels/content/side-panel/slice.new"
import { getAncestors } from "panels/content/side-panel/utils"
import { selectAllEntitiesMap } from "panels/content/side-panel/slice"
import { selectHoveredBoundingBoxId } from "features/entity-caching/flights/selectors"

export const BoundingBoxLabels = () => {
    const boundingBoxLayerData = useBoundingBoxLayerLabelData()
    const hoveredBoundingBoxId = useAppSelector(selectHoveredBoundingBoxId)
    const selectedLayerIds = useAppSelector(selectSelectedLayerIds)
    const lockedLayersById = useAppSelector(selectLockedLayersMap)
    const entityMap = useAppSelector(selectAllEntitiesMap)
    return (
        <>
            {boundingBoxLayerData.flatMap((layerData) => {
                return layerData.map((data) => {
                    const entity = entityMap[data.id]

                    if (
                        (hoveredBoundingBoxId !== entity.id &&
                            !selectedLayerIds.includes(entity.id)) ||
                        lockedLayersById[entity.id] ||
                        !!getAncestors(entity.id, entityMap).find((ancestor) => ancestor.locked)
                    )
                        return null

                    return (
                        <Marker
                            latitude={data.polygon[0][1]}
                            longitude={data.polygon[0][0]}
                            anchor="left"
                            offset={[0, -16]}
                            key={data.id}
                        >
                            <div
                                className="bg-white-800 text-grey-900 px-1 py-[2px] flex justify-center items-center border border-black-300"
                                style={{ borderRadius: "6px" }}
                            >
                                <small style={{ fontSize: "11px" }}>{entity.name}</small>
                            </div>
                        </Marker>
                    )
                })
            })}
        </>
    )
}
